import {RouteEntry} from "../../shared/routes";
import {MyDetails} from "./MyDetails";

export const myDetailsRoutes: Array<RouteEntry> = [
    { path: '/my-details/:id', component: MyDetails },
    { path: '/my-details', component: MyDetails },
];
